module.exports = __webpack_public_path__ + "static/media/Volcarona_gaussian2.acfcec37.png";